import { Navigate, Outlet, useLocation } from "react-router-dom";

import { LoadingState } from "@/components/feedback/LoadingState";

import { useAuth } from "./useAuth";

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingState message="Validando sessao..." />;
  }
  if (!user) {
    const search = new URLSearchParams({ next: location.pathname }).toString();
    return <Navigate to={`/login?${search}`} replace />;
  }
  return <Outlet />;
}
